import React from "react";

function MultilingualThird() {
  return (
    <div className="bg-midBlueNew">
      <div className="w-11/12 lg:w-10/12 2xl:w-9/12 max-w-7xl mx-auto pt-[80px] pb-[64px]">
        <h2 className="text-40 text-white text-center leading-[60px] font-secondary mb-16">
          What makes our translation &nbsp;
          <span className="md:block">services different?</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-7 xl:gap-9">
          <div className="flex flex-col items-center gap-6">
            <p className="text-5xl text-orange font-secondary font-bold">98%</p>
            <p className="text-xl text-white text-center font-secondary font-medium">
              Customer <br />
              Satisfaction Rate
            </p>
            <p className="text-17 text-[#C5C2C2] leading-6 text-center font-opensans">
              Our customers agree that Tomedes is the translation company to
              beat.
            </p>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="text-5xl text-orange font-secondary font-bold">
              20,000
            </p>
            <p className="text-xl text-white text-center font-secondary font-medium">
              Native <br />
              Translators
            </p>
            <p className="text-17 text-[#C5C2C2] leading-6 text-center font-opensans">
              A global pool of native translators at your service, anytime,
              anywhere.
            </p>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="text-5xl text-orange font-secondary font-bold">15</p>
            <p className="text-xl text-white text-center font-secondary font-medium">
              Years Of Professional <br />
              Translation Experience
            </p>
            <p className="text-17 text-[#C5C2C2] leading-6 text-center font-opensans">
              We’ve had more than a decade of experience optimizing our
              services.
            </p>
          </div>
          <div className="flex flex-col items-center gap-6">
            <p className="text-5xl text-orange font-secondary font-bold">120</p>
            <p className="text-xl text-white text-center font-secondary font-medium">
              Languages & <br />
              950+ Language Pairs
            </p>
            <p className="text-17 text-[#C5C2C2] leading-6 text-center font-opensans">
              We have the language pair you need to bring meaning to your words.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MultilingualThird;
